import { render, staticRenderFns } from "./bloodFat.vue?vue&type=template&id=7a4b0f3f&scoped=true"
import script from "./bloodFat.vue?vue&type=script&lang=js"
export * from "./bloodFat.vue?vue&type=script&lang=js"
import style0 from "./bloodFat.vue?vue&type=style&index=0&id=7a4b0f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4b0f3f",
  null
  
)

export default component.exports